var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"text-caption"},[_vm._v(_vm._s(_vm.getFormattedTime(_vm.value.created_at)))]),_c('span',{staticClass:"text-caption"},[_vm._v(_vm._s(_vm.value.created_by))]),_c('span',[_vm._v(_vm._s(_vm.value.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }